import axios from 'axios';

const BaseUrl = `${process.env.REACT_APP_PAYINAPOAPI_BASE_URL}`;
//const BaseUrl = "https://localhost:44377/api/";

export async function GetAllUsers (UserId){
    const response = await axios.get(`${BaseUrl}Users/GetAll/${UserId}`);
    return response.data;
}

export async function GetUserById(id){
    const response = await axios.get(`${BaseUrl}Users/GetUserById/${id}`)
    return response.data;
}

export async function CreateUser(user){
    const response = await axios.post(`${BaseUrl}Users/CreateUser`,user)
    console.log("///Create User",response.data)
    return response.data;
}
export async function UpdateUser(user){
    const response = await axios.post(`${BaseUrl}Users/UpdateUser`,user)
    return response.data;
}
export async function CompleteProfile(data){
    const response = await axios.post(`${BaseUrl}Users/CompleteProfile`,data)
    return response.data;
}

export async function CheckUserStatus(userId){
    const response = await axios.get(`${BaseUrl}Users/CheckProfileStatus/${userId}`)
    console.log(response.data);
    return response.data;
}

export async function UploadImages(data){
    const config = {headers: {"content-type": "multipart/form-data"}};
    const response = await axios.put(`${BaseUrl}Image/UploadImages`,data,config)
    console.log('UI 33',response.data);
    return response.data;
}

export async function UpdateBio(userId,bio){

    const config = { headers: {"Content-Type": "application/json"} };

        try{
            const response = await axios.put(`${BaseUrl}Users/UpdateUserBio/${userId}`,JSON.stringify(bio),config)
            return response.data;
        }
        catch (error) {

                console.error('Error message:', error.message);
        }
}

export async function UpdateCountry(userId,country){

    const config = { headers: {"Content-Type": "application/json"} };

    try{
        const response = await axios.put(`${BaseUrl}Users/UpdateUserCountry/${userId}`,JSON.stringify(country),config)
        console.log(response.data);
        return response.data;
    }catch(error){
        console.error('Error message:', error.message);
    }
}

export async function RemoveImage(id){
    const response = await axios.delete(`${BaseUrl}Image/RemoveImage?imageId=${id}`)
    return response.data;
}

export async function UpdateProfileImage(id,imageObject){
    console.log(id,imageObject._parts);
    const config = {headers: {"content-type": "multipart/form-data"}};
    const response = await axios.put(`${BaseUrl}Users/UpdateProfileImage/${id}`,imageObject,config)
    .then(response => console.log(response.data))
    .catch (error => {
        if (error.response) {
            console.log(error.response.data,"response data");
            console.log(error.response.status,"response status");
            console.log(error.response.headers, "headers");
          } else if (error.request) {
            console.log(error,"error");
          } else {
            console.log('Error', error.message);
          }
          console.log(error.config,"error config");
      })
}
export async function GetUserNotificationsById(id){
    const response = await axios.get(`${BaseUrl}Notification/GetNotificationsByUserId/${id}`)
    console.log('NOTIF 76 /////',response.data)
    return response.data;
}

export async function AddLike(data){
    try {
        const response = await axios.post(`${BaseUrl}Like/AddLike`,data)
        console.log('+ Like ////// 81',response.data);
        return response.data;
    } catch (error) {
        const status = error.response?.status;
        if (error.response?.data != null && status != null && status < 500) {
            console.log('+ Like error body //////', error.response.data);
            return error.response.data;
        }
        throw error;
    }
}
export async function AddDislike(data){
    const response = await axios.post(`${BaseUrl}Dislike/AddDislike`,data)
    console.log('+ Dislike ////// 81',response.data);
    return response.data;
}
export async function AddInterest(data){
    const response = await axios.post(`${BaseUrl}Interest/AddInterest`,data)
    //console.log('+ Like ////// 86',response.data);
    return response.data;
}
export async function RemoveInterest(data){
    const response = await axios.delete(`${BaseUrl}Interest/RemoveInterest`,data)
    //console.log('+ Like ////// 81',response.data);
    return response.data;
}
export async function GetAllInterestsByUserId(UserId){
    const response = await axios.get(`${BaseUrl}Interest/GetAllInterestsByUserId/${UserId}`) 
    //console.log('+ Like ////// 81',response.data);
    return response.data;
}
export async function ToggleInterest(data){
    const response = await axios.post(`${BaseUrl}Interest/ToggleInterest`,data)
    console.log('+ Interest ////// 101',response.data);
    return response.data;
}
export async function CheckIfInterestExist(data){
    const response = await axios.post(`${BaseUrl}Interest/CheckIfInterestExist`,data)
    console.log('+ Interest ////// 101',response.data);
    return response.data;
}

export async function GetUserRecommendations(UserId){
    const response = await axios.get(`${BaseUrl}Users/recommendations/${UserId}`,
        {
            withCredentials: true
        }
    ) 
    return response.data;
}



export async function DeleteAccount(UserId){
    console.log('USERID',UserId);
    const response = await axios.delete(`${BaseUrl}Account/DeleteAccount/${UserId}`)
    console.log('///138 REPONSE',response.data)
    return response.data;
}
export async function findLike(data){
    const response = await axios.post(`${BaseUrl}Like/FindLike`,data)
    console.log('+ Interest ////// 101',response.data);
    return response.data;
}
export async function DeleteNotification(notificationId){
    const response = await axios.delete(`${BaseUrl}Notification/RemoveNotification?notificationId=${notificationId}`)
    console.log('+ Interest ////// 101',response.data);
    return response.data;
}
export async function AddMatch(data){
    const response = await axios.post(`${BaseUrl}Match/AddMatch`,data)
    console.log('/// Adding match result Response : ',response.data);
    return response.data;
}
export async function GetMatchesByUserId(userId){
    const response = await axios.get(`${BaseUrl}Match/GetMatchesByUserId?userId=${userId}`)
    console.log('///Response : ',response.data);
    return response.data;
}
export async function DeleteMatchBySendbirdId(sendbirdId){
    const response = await axios.delete(`${BaseUrl}Match/DeleteMatchBySendbirdId?sendbirdId=${sendbirdId}`)
    console.log('/// Response :',response.data);
    return response.data;
}
export async function GetTodayLikeCount(userId){
    const response = await axios.get(`${BaseUrl}Like/TodayLikeCount?userId=${userId}`)
    console.log('/// Response :',response.data);
    return response.data;
}

export async function GetUserImages(userId){
    const response = await axios.get(`${BaseUrl}Users/${userId}/images`)
    return response.data;
}

export async function DeactivateUser(userId){
    const response = await axios.post(`${BaseUrl}Users/Deactivate/${userId}`)
    return response.data;
}
export async function ActivateUser(userId){
    const response = await axios.post(`${BaseUrl}Users/Activate/${userId}`)
    return response.data;
}
export async function GetUserAccountStatus(userId){
    const response = await axios.get(`${BaseUrl}Users/accountstatus/${userId}`)
    return response.data;
}
export async function GetLikesNotifications(userId){
    const response = await axios.get(`${BaseUrl}Notification/GetLikeNotificationsByUserId/${userId}`)
    return response.data;
}
export async function GetMatchesNotifications(userId){
    const response = await axios.get(`${BaseUrl}Notification/GetMatchNotificationsByUserId/${userId}`)
    return response.data;
}
export async function UpdateUserLocation(data){
    const response = await axios.post(`${BaseUrl}Users/updateUserLocation`,data)
    console.log('+ Location Updated ////// 101',response.data);
    return response.data;
}
export async function GetSubscriptionStatus(subscriptionId){
    const response = await axios.get(`${BaseUrl}subscription/checkSubscriptionStatus/${subscriptionId}`)
    return response.data;
}

export async function UpdateUserPreferences(data){
    const response = await axios.post(`${BaseUrl}Users/UpdateUserPreferences`,data)
    return response.data;
}
export async function GetUserPreferences(userId){
    const response = await axios.get(`${BaseUrl}Users/GetUserPreferences/${userId}`)
    return response.data;
}
export async function GetConversationById(conversationId){
    const response = await axios.get(`${BaseUrl}Conversations/${conversationId}`)
    return response.data;
}
export async function GetUserConversations(userId){
    const response = await axios.get(`${BaseUrl}Conversations/user/${userId}`)
    console.log('/// Conversations Response : ',response.data);
    return response.data;
}
export async function SendMessage(data){
    console.log('/// Send Message Data : ',data);
    const response = await axios.post(`${BaseUrl}Messages/sendMessage`,data,{
        headers: {
            'Content-Type': 'application/json'
        }
    }
    )
    return response.data;
}
export async function GetMessagesByConversationId(conversationId){
    const response = await axios.get(`${BaseUrl}Messages/${conversationId}`)
    return response.data;
}
export async function DeleteUser(userId){
    const response = await axios.delete(`${BaseUrl}Users/DeleteUser/${userId}`)
    console.log('/// Delete User Response : ',response.data);
    return response.data;
}